import { UserData } from "../../../Context/DataContext";
import { RandomId } from "../../../Utils/RandomId";
import { KeepAliveClick } from "../../../Utils/inheritance";
import styles from "./styles/KeepAlive.module.css";
import keepAliveBG from "./styles/img/keepAliveBG.svg";
import keepAliveIcon from "./styles/img/keepaliveicon.svg";
import React, { useEffect } from "react";
function KeepAlive({
  onClose,
  text = "Keep Alive Pending Notification",
  OnConfirm,
  confirm_button = "I'M ALIVE",
  title = "Welcome Back!",
}) {
  const userData = UserData();

  useEffect(() => {
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);
  const handleClick = () => {
    const new_inheritance_parameters = KeepAliveClick(
      userData.UserData.keep_alive_timeout,
      userData.UserData.inheritance_parameters
    );
    userData.setUserData({
      ...userData.UserData,
      inheritance_parameters: new_inheritance_parameters,
      last_login: Number(Date.now()),
    });
    userData.setCustomerUser({
      ...userData.CustomerUser,
      self_recovery_status: "inactive",
    });
    userData.Update(RandomId(3));
    onClose();
  };
  return (
    <div className={styles.background}>
      <div
        onClick={(e) => {
          e.stopPropagation();
        }}
        className={styles.new_main_box}
      >
        <img
          src={keepAliveBG}
          className={styles.keepalivebg}
          alt="keep alive"
        />
        <div className={styles.new_main_box_first_row}>
          <img
            style={{
              width: "50px",
            }}
            src={keepAliveIcon}
            alt="keep alive"
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "2px",
            }}
          >
            <p>{title}</p>
            <div
              style={{
                height: "1px",
                width: "85%",
                backgroundColor: "rgba(156, 183, 212, 1)",
              }}
            />
          </div>
        </div>{" "}
        <p className={styles.new_main_box_text}>{text}</p>
        <div onClick={() => handleClick()} className={styles.new_save_button}>
          {confirm_button}
        </div>
        {/* <div className={styles.title}>{text}</div>
        <div className={styles.main_data}>
          <div className={styles.buttons_div}>
            <div onClick={() => handleClick()} className={styles.save_button}>
              {confirm_button}
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
}

export default KeepAlive;
